import * as React from "react";
import { DefaultToastContainer } from "react-toast-notifications";
import { Transition } from "semantic-ui-react";
interface IToastContainerProps {}

export const ToastContainer: React.FC<IToastContainerProps> = props => {
  return <DefaultToastContainer {...props} className="toast-container" />;
};
